import { RequestTypes } from '../../../hooks/useRequest'

export const GENERATION_API_PREFIX = '/api/green-tools/v1/'
export const GENERATION_GRAPH_BLOCK = 'frontpage-green-tools-stats'

export const EXTENSION_API_PREFIX = '/api/extension/v1/'
export const COUNTED_GRAPH_BLOCK = 'extension/stats/green-tools/counted'

export const getGraphData = {
    link: `${GENERATION_API_PREFIX}${GENERATION_GRAPH_BLOCK}`,
    method: RequestTypes.get,
}

export const getCountedData = {
    link: `${EXTENSION_API_PREFIX}${COUNTED_GRAPH_BLOCK}`,
    method: RequestTypes.get,
}
